import Vue from 'vue'
import Vuex from 'vuex'
import Axios from 'axios'
import Prismic from 'prismic-javascript'
import dayjs from 'dayjs'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    apiEndpoint: 'https://ftiam.prismic.io/api/v2',
    events: [],
    weather: [],
    texts: [],
    pages: {
      'acknowledgements': {
        id: 'XH0oQBIAACIAWYlo',
        content: false
      },
      'about': {
        id: 'XH0n7RIAACAAWYfz',
        content: false
      },
      'artist': {
        id: 'XH0VehIAACIAWTaO',
        content: false
      },
      'contact': {
        id: 'XH1sGBIAAB8AWrDJ',
        content: false
      },
      'gallery': {
        id: 'XIKkeRIAAB8AcQfh',
        content: false
      },
      'learning-resource': {
        id: 'XH0orRIAACIAWYtM',
        content: false
      },
      'map': {
        id: 'XHPKHhIAACIAMKRF',
        content: false
      },
      'press': {
        id: 'XHPKHhIAACIAMKRF',
        content: false
      },
      'visitor-information': {
        id: 'XH0U9BIAAB8AWTQq',
        content: false
      }
    }
  },
  mutations: {
    SET_EVENTS (state, payload) {
      state.events = payload
    },
    UPDATE_PAGE (state, payload) {
      state.pages[payload.slug].content = payload.data
    },
    SET_WEATHER (state, payload) {
      state.weather = payload
    }
  },
  actions: {
    loadData (context) {
      if (!context.state.events.length) {
        Prismic.getApi(context.state.apiEndpoint).then(function(api) {
          api.query(
            Prismic.Predicates.at('document.type', 'event'),
            {
              pageSize : 50,
              page : 1,
              orderings : '[my.event.date]',
              fetchLinks: ['text.title', 'text.author']
            }
          ).then(function(response) {
            context.commit('SET_EVENTS', response.results)
          })
        })
      }

      if (!context.state.weather.length) {
        Axios.get('https://www.firstthereisamountain.com/api/weather').then(response => {
        context.commit('SET_WEATHER', response.data.data)
        }).catch(e => {
          context.commit('SET_WEATHER', e)
        })
      }
    },
    loadPage (context, payload) {
      let page = context.state.pages[payload]
      if (!page.content) {
        let id = page.id
        Prismic.getApi(context.state.apiEndpoint).then(function(api) {
          api.getByID(id).then(function(response) {
            context.commit({
              type: 'UPDATE_PAGE',
              slug: payload,
              data: response.data
            })
          })
        })
      }
    }
  },
  getters: {
    nextEvent (state) {
      if (state.events) {
        return state.events.find((x) => {
         return dayjs().isBefore(dayjs(x.data.date)) || dayjs().isSame(dayjs(x.data.date))
        })
      } else {
        return false
      }
    }
  }
})
